import { Select, MenuItem, SelectChangeEvent } from '@mui/material';
import clsx from 'clsx';

import { ArrowLeftIcon, ArrowRightIcon } from 'components/common/Icons/Icons';

import styles from './Pagination.module.scss';

export interface PaginationProps {
  pageIndex: number;
  itemsPerPage: number;
  itemsTotal: number;
  pagesCount: number;
  onPageIndexChange: (page: number) => void;
}

const Pagination = ({ pageIndex, pagesCount, itemsPerPage, itemsTotal, onPageIndexChange }: PaginationProps) => {
  const firstElementsNumberOnPage = pageIndex * itemsPerPage + 1;
  const lastElementsNumberOnPage = Math.min((pageIndex + 1) * itemsPerPage, itemsTotal);
  const isPrevButtonDisabled = pageIndex === 0;
  const isNextButtonDisabled = pageIndex + 1 === pagesCount;
  const pageNumbers = Array.from(Array(pagesCount).keys());

  const handlePageIndexChange = (event: SelectChangeEvent<number>) => {
    onPageIndexChange(Number(event.target.value));
  };

  const handlePreviousPage = () => {
    onPageIndexChange(pageIndex - 1);
  };

  const handleNextPage = () => {
    onPageIndexChange(pageIndex + 1);
  };

  return (
    <div className={styles.paginationContainer}>
      <div className={styles.pageControls}>
        <div className={styles.pageNumberDescription}>
          <span>Page</span>
          <Select
            id="select-id"
            labelId="select-label-id"
            className={styles.pageSelectRoot}
            classes={{
              icon: styles.selectIcon,
              select: styles.pageSelect,
            }}
            value={pageIndex}
            onChange={handlePageIndexChange}
          >
            {pageNumbers.map((pageNumber) => {
              return (
                <MenuItem key={pageNumber} value={pageNumber}>
                  {pageNumber + 1}
                </MenuItem>
              );
            })}
          </Select>
          <span>of {pagesCount} </span>
        </div>
        <div className={styles.pageButtons}>
          <button
            type="button"
            onClick={handlePreviousPage}
            disabled={isPrevButtonDisabled}
            className={clsx(styles.pageButton, { [styles.pageButtonDisabled]: isPrevButtonDisabled })}
          >
            <ArrowLeftIcon />
          </button>
          <button
            type="button"
            onClick={handleNextPage}
            disabled={isNextButtonDisabled}
            className={clsx(styles.pageButton, { [styles.pageButtonDisabled]: isNextButtonDisabled })}
          >
            <ArrowRightIcon />
          </button>
        </div>
      </div>
      <div>
        <p>
          {firstElementsNumberOnPage}-{lastElementsNumberOnPage} out of {itemsTotal}
        </p>
      </div>
    </div>
  );
};

export default Pagination;
